export default {
  TXT_PAGE_NOT_FOUND: "404: Trang bạn tìm kiếm không tồn tại",
  TXT_PAGE_NOT_FOUND_DESCRIPTION:
    "Trang bạn mở hiện không tìm thấy trên hệ thống, hãy trở về trang chủ để thực hiện tiếp",
};
